<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="card">
                <div class="card-header border-0">
                </div>
                <div class="table-responsive">
                    <vue-good-table
                            :columns="columns"
                            :rows=acceptedLoans
                            :line-numbers="true"
                            :search-options="{
                        enabled: true,
                        }"
                            :sort-options="{
                        enabled: true}"
                            :pagination-options="{
                enabled: true,
                perPage: 5
                }"
                            styleClass="table table-striped table-no-bordered table-hover">
                        <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field == 'action'">
            <base-button type="danger" size="sm" @click="viewSummary(props.row)">View Summary</base-button>
            <base-button type="primary" size="sm" @click="payment(props.row)">Add Payment</base-button>
            <base-button type="warning" size="sm" @click="repayment(props.row)">Statement</base-button>
    </span>
                            <span v-else>
      {{props.formattedRow[props.column.field]}}
    </span>
                        </template>
                    </vue-good-table>
                </div>
            </div>
            <!-- Modal -->
        </base-header>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
    export default {
        name: "addPayments",
        data() {
            return {
                amount: '',
                columns: [
                    {
                        label: 'Approved Date',
                        field: 'approved_date',
                        formatFn: this.formatDate,
                    },
                    {
                        label: 'Approved Amount',
                        field: 'approved amount',
                        formatFn: this.formatCost,
                    },
                    {
                        label: 'Current Balance',
                        field: 'current_balance',
                        formatFn: this.formatCost,
                    },
                    {
                        label: 'Action',
                        field: 'action',
                    },
                ],
            }
        },
        created() {
            this.authorizedUser(this.authorizeAdminOnly);
            this.$store.dispatch('viewallAcceptedLoans_function');
        },
        methods: {
            repayment(params){
                this.$router.push({
                    path: 'loanRepayment',
                    query: {
                        loanId: params.loan_application_public_id,
                    },
                });
            },
            viewSummary(params) {
                this.$router.push({
                    path: 'loanSummary',
                    query: {
                        loanId: params.loan_application_public_id,
                    },
                });
            },
            async payment(params){
                const { value: amount } = await Swal.fire({
                title: 'Enter Sacco Payment',
                input: 'text',
                inputPlaceholder: 'Enter your payment',
                showCancelButton: true,
                })
                if (amount) {
                this.amount = amount
                const data = {
                    amount: this.amount,
                    public_id : params.loan_public_id
                }
                console.log(data)
                 this.$store.dispatch('addPayment_function', data)
                }
            },
            formartDate(date) {
                return moment(date).format('Do MMMM  YYYY');
            },
            formatCost(amount) {
                const result = Number(amount).toLocaleString()
                if (result !== 0) {
                    return `Ksh. ${result}`;
                } else {
                    return '0';
                }
            },
            formatStatus(value){
                if (value === '15'){
                    return 'Pending';
                }else {
                    return value;
                }
            }
        },
    }
</script>

<style scoped>

</style>
